import { Badge, Text } from "@stone-payments/jade";
import { Mask } from "@/utils/masks";
import { Skeleton } from "@/components/skeleton";
import { QuantitySelector } from "@/components/quantity-selector";

type CartQuantityProps = {
  price: number;
  quantity: number;
  setQuantity: (quantity: number) => void;
  loading?: boolean;
  disabled?: boolean;
};

const Loading = () => {
  return (
    <div
      className="mb-jade-250 flex justify-between"
      aria-label="Quantidade do produto"
    >
      <QuantitySelector loading />
      <Skeleton className="rounded-sm" height="h-12" width="w-20" />
    </div>
  );
};

export const CartQuantity = ({
  price,
  quantity,
  setQuantity,
  loading = true,
  disabled = false,
}: CartQuantityProps) => {
  if (loading) return <Loading />;

  const addQuantity = () => {
    setQuantity(quantity + 1);
  };

  const subtractQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };
  const className = disabled ? "line-through" : "";

  return (
    <div
      className="mb-jade-250 flex justify-between"
      aria-label="Quantidade do produto"
    >
      <QuantitySelector
        quantity={quantity}
        onIncrease={addQuantity}
        onDecrease={subtractQuantity}
        disabled={disabled}
      />

      <div className="flex flex-col items-end gap-jade-50">
        <div className="flex gap-jade-50">
          {price ? (
            <Badge
              variant="text"
              label={`${quantity}x`}
              voice="negative"
              inactive
            />
          ) : null}

          <Text
            variant="text-small"
            color={disabled ? "low" : "medium"}
            weight="semibold"
          >
            <span className={className}>
              {price ? Mask.formatToBrlCurrency(price) : ""}
            </span>
          </Text>
        </div>

        <Text variant="heading-small" color={disabled ? "low" : "high"}>
          <span className={className}>
            {price ? Mask.formatToBrlCurrency(price * quantity) : ""}
          </span>
        </Text>
      </div>
    </div>
  );
};
